import React from 'react';
import DeniedFAReviewContent from './DeniedReviewContent';
import FAApprovedReviewContent from './ApprovedReviewContent';
import FADefaultReviewContent from './DefaultReviewContent';
import { financialAssistanceReferralDetailsPropType } from './types';

const propTypes = {
    details: financialAssistanceReferralDetailsPropType.isRequired,
};

const defaultProps = {};

function ContentByStatus({ details }) {
    if (details.status.toUpperCase() === 'DENIED') {
        return <DeniedFAReviewContent financialAssistanceReferralDetails={details} />;
    }
    if (['APPROVED', 'PARTIALLY APPROVED'].includes(details.status.toUpperCase())) {
        return <FAApprovedReviewContent financialAssistanceReferralDetails={details} />;
    }
    return <FADefaultReviewContent financialAssistanceReferralDetails={details} />;
}

ContentByStatus.propTypes = propTypes;
ContentByStatus.defaultProps = defaultProps;

export default ContentByStatus;
